module.exports = __webpack_public_path__ + "img/sem-imagem.6371190c.jpg";